<template>
  <main-layout>
    <!-- 左メニュー -->
    <div slot="left-side">
      <menubar screenIdParam="M-06-104"></menubar>
    </div>

    <!-- ヘッダー行 -->
    <el-row slot="header">
      <head-title class="cancel-width">
        <label slot="title"> {{$t('label.router.commonItemEdit')}}</label>
        <button-index slot="cancel" @click="back">
          {{ $t("button.common.data.cancel") }}
        </button-index>
        <narrow-down slot="create" @click="createOrUpdataOption">
          {{ $t('label.system.option.save') }}
        </narrow-down>
      </head-title>
    </el-row>
    <!-- メインページ -->
    <div slot="body">
      <div style="display: flex;flex-direction: column;">
        <span class="common-title-style">
          {{ $t('label.system.option.commonItem')  }}
        </span>
        <span class="common-remark-style">
          {{ $t('label.system.option.commonRemark')  }}
        </span>
      </div>
      <el-form
        :model="query"
        :rules="rules"
        ref="ruleForm"
        label-position="left">
          <!-- 質問 -->
          <div class="mark-question-area m-top-32" v-show="questionAreaFlag">
            <div class="m-bottom-10">
              <el-form-item>
                <el-input
                  v-model="query.questionContent"
                  :placeholder="$t('label.help.que.inputQuestion')"
                  @mousedown.native="handQuestionArea"/>
              </el-form-item>
            </div>
            <div>
              <el-radio>
                {{ $t('label.help.que.option') }}
              </el-radio>
            </div>
          </div>

          <div v-for="(question, index) in query.questionList" :key="index" class="authentic-question-area m-top-32"  v-show="questionAreaFlag === false">

            <div class="form-group with-100">
              <div class="with-100">
                <div>
                  <el-form-item
                    :prop="`questionList.${index}.questionContent`">
                    <el-input
                      maxlength="50"
                      show-word-limit
                      v-model="question.questionContent"
                      :placeholder="$t('label.help.que.inputQuestion')"
                    />
                  </el-form-item>
                  <hr class="delimit-8"/>
                </div>
              </div>

            </div>

            <div v-for="(answ, optionIndex) in question.questionAnswerList" :key="optionIndex" >
              <!-- 1つ選択 -->
              <div v-if="question.questionInputMode === '02' && question.questionAnswerList.length > 0">
                <div class="form-group m-top-3">
                  <el-radio :disabled="true">
                    <template v-slot:label>
                      <span class="displaynone"></span>
                    </template>
                  </el-radio>


                  <!-- その他ない -->
                  <div v-if="answ.type === 'input'" class="form-group width-100">
                    <el-form-item class="width-100" :prop="`questionList.${index}.questionAnswerList.${optionIndex}.content`">
                      <el-input
                        v-model="answ.content"
                        show-word-limit
                        maxlength="50"
                        class="width-888 weight-size-300"
                        :placeholder="$t('label.help.que.input')">
                      </el-input>
                    </el-form-item>
                    <img src="@/assets/icon/icon-close-policy.svg" alt="" @click="removeAnswer(index, optionIndex)" class="m-left-22 cur-pointer"/>
                  </div>
                </div>
              </div>
            </div>


            <div class="form-group m-top-3">
              <img src="@/assets/icon/sp-btn-add.svg" alt="" class="img-w-height"/>
              <span class="m-left-2 weight-size-600 cur-pointer" @click="addTypeInput(index,question)">{{ $t('label.help.que.addOption') }}</span>
            </div>

            <div class="form-group m-top-3">
              <span class="weight-size-600">{{ $t('label.help.que.must') }}</span>
              <el-switch v-model="question.mustFlag" class="m-left-1"></el-switch>
              <div style= "display: contents;">
                <span class="m-left-3 font-style">{{ $t("label.help.que.deleteQuestion") }}</span>
                <img src="@/assets/icon/icon_point_delete.svg" class="cur-pointer" @click="removeQuestion(index)"/>
              </div>
            </div>
          </div>

          <div class="m-top-6 flex-space-between-center width-100">
            <!-- 確認 -->
            <div>
              <narrow-down @click="createOrUpdataOption">
                {{ $t('label.system.option.save') }}
              </narrow-down>
            </div>
            <!--   ヘッダー行 終了   -->
            <div class="form-group cur-pointer" @click="addNewQuestionArea" v-if="query.questionList.length == 0">
              <span class="weight-size-600">{{ $t('label.help.que.addQuestion') }}</span>
              <img src="@/assets/icon/sp-btn-add.svg" alt="" class="img-w-height-36 m-left-2"/>
            </div>
          </div>
      </el-form>
      <loading-dialog :dialogVisible="showLoading" />
    </div>
  </main-layout>
</template>

<script>
import NewDesignLayout from "@/layout/NewDesignLayout"
import narrowDown from "@/components/common/generalButton/NarrowDown"
import headTitle from "@/components/common/head/head"
import Menubar from "@/components/leftmenu/DashBoard"
import buttonIndex from "@/components/common/sp-smart-button/index";
import SystemManageApi from "@/api/SystemManageApi";
import errorCodeMsg from "@/utils/error-code-msg";
import LoadingDialog from "@/components/common/loading/LoadingDialog"


export default {
  name: "BuildingSearch",
  components: {
    MainLayout: NewDesignLayout,
    headTitle: headTitle,
    narrowDown: narrowDown,
    Menubar: Menubar,
    buttonIndex:buttonIndex,
    LoadingDialog:LoadingDialog,
  },
  data() {
    var questionContentValidator = (rule, value, callback) => {
      const isDuplicate = this.query.questionList.some((item, idx) => {
        return item.questionContent === value && idx !== parseInt(rule.fullField.split('.')[1]);
      });

      if(this.$IsNullOrEmpty(value)){
        callback(new Error(this.$t("message.common.validation.required", {
          field:  this.$t('label.help.question.common.question')
        })))
      } else if(isDuplicate) {
        callback(new Error(this.$t("message.common.validation.questionDuplicate",{
          field:  this.$t('label.help.question.common.question')
        })))
      } else {
        callback();
      }
    };
    return {
      otherFlag: "true",
      questionAreaFlag: true,
      buildingId:null,
      commonOptionId:null,
      showLoading:false,
      createFlag:true,
      query: {
        commonQuestionFlag:false,
        questionList: [{
          questionInputMode: "02",
          mustFlag: true,
          maxLength: null,
          questionAnswerList: [
            {
              type: 'input',
              content: null,
              otherExistsFlag: false
            }
          ]
        }],
      },
      dynamicRules: {
        questionContent: [
          {
            validator: questionContentValidator,
            trigger: ['change','blur']
          }
        ],
        optionContent: [
          {
            required: true,
            message: this.$t('message.common.validation.required', {
              field:  this.$t('label.sns.question.choiceContent')
            }),
            trigger: 'change'
          }
        ]
      },

    }
  },
  methods: {

    addNewQuestionArea() {
      if (this.questionAreaFlag === false) {
        const newQuestion = {
          questionContent: '',
          selectedOption: {
            label: '02',
            icon: '@/assets/icon/sp-icon-select-choose-1.svg',
            value: '1つ選択'
          },
          questionInputMode: "02",
          mustFlag: true,
          maxLength: null,
          questionAnswerList: [
            {
              type: "input",
              content: null,
              otherExistsFlag: false,
            }
          ]
        };
        this.query.questionList.push(newQuestion);
      }
    },

    removeAnswer(index, optionIndex) {
      const question = this.query.questionList[index];
      question.questionAnswerList.splice(optionIndex, 1);

      if (question.questionAnswerList.length === 0) {
        this.query.questionList.splice(index, 1);
      }
    },
    hasOtherExistsFlag(question) {
      return question.questionAnswerList.some(answer => answer.otherExistsFlag);
    },
    addTypeInput(index,value) {
      if (value.questionInputMode != null) {
        const question = this.query.questionList[index];
        question.maxLength = null;
        const questionAnswerList = question.questionAnswerList;

        let foundOtherIndex = -1;
        for (let i = 0; i < questionAnswerList.length; i++) {
          if (questionAnswerList[i].type === 'other') {
            foundOtherIndex = i;
            break;
          }
        }

        const newObj = {
          type: 'input',
          radioValue: '',
          choiceContent: '',
          content: '',
          otherExistsFlag: false,
        };

        if (foundOtherIndex !== -1) {
          const targetIndex = foundOtherIndex > 0 ? foundOtherIndex - 1 : 0;
          questionAnswerList.splice(targetIndex + 1, 0, newObj);
        } else {
          const lastIndex = questionAnswerList.length > 0 ? questionAnswerList.length - 1 : 0;
          questionAnswerList.splice(lastIndex + 1, 0, newObj);
        }
      }
    },
    removeQuestion(index) {
      this.query.questionList.splice(index, 1);
    },
    handQuestionArea() {
      this.questionAreaFlag = false;
    },
    back(){
      this.$router.push({
        name: "reserveOptipnList",
        params: {
          buildingId: this.buildingId
        }
      })
    },
    getCommonOption(){
      SystemManageApi.getReservationOptionDetail(this.commonOptionId)
      .catch((error) => {
        errorCodeMsg(error, this)
      })
      .then(({data}) => {
        if(data.statusCode == "Success") {
          this.commonQuestion = null
          if(data.body.optionDetailList != null && data.body.optionDetailList.length > 0){
            let questionAnswerList = []
            for(let choice of data.body.optionDetailList[0].choiceList){
              questionAnswerList.push({
                choiceId:choice.choiceId,
                choiceUUId:choice.choiceUUId,
                type: 'input',
                content:choice.choiceContent,
                otherExistsFlag:false,
              })
            }
            this.query.commonQuestionFlag = data.body.commonFlag
            this.query.questionList = []
            this.query.questionList.push({
              detailId:data.body.optionDetailList[0].detailId,
              detailUUId:data.body.optionDetailList[0].detailUUId,
              questionInputMode:data.body.optionDetailList[0].inputMode,
              questionContent:data.body.optionDetailList[0].content,
              selectedOption: {
                label: '02',
                icon: '@/assets/icon/sp-icon-select-choose-1.svg',
                value: '1つ選択'
              },
              mustFlag: data.body.optionDetailList[0].mustFlag,
              maxLength: null,
              questionAnswerList:questionAnswerList
            })
            this.questionAreaFlag = false
          }
        }
      }).finally(() => {})
    },
    createOrUpdataOption(){
      this.showLoading = true
      if(!(this.query.questionList != null && this.query.questionList.length > 0)){
        this.$messageIotError(this.$t('質問項目を空にすることはできません'))
        this.showLoading = false
        return;
      }
      this.$refs["ruleForm"].validate((valid) => {
        if(valid){
          if(this.createFlag){
            let optionDetailList = []
            let choiceList = []
            for(let choice of this.query.questionList[0].questionAnswerList){
              choiceList.push({
                choiceContent : choice.content,
                otherFlag : choice.otherExistsFlag
              })
            }
            optionDetailList.push({
              content : this.query.questionList[0].questionContent,
              commonFlag : true,
              inputMode : this.query.questionList[0].questionInputMode,
              mustFlag : this.query.questionList[0].mustFlag,
              choiceList : choiceList
            })

            let query = {
              optionTitle : '共通',
              buildingId : this.buildingId,
              optionRemark : null,
              commonShowFlag : false,
              commonFlag : true,
              optionDetailList : optionDetailList
            }

            SystemManageApi.createBuildReservationOption(query)
            .catch((error) => {
              errorCodeMsg(error, this)
              this.showLoading = false
            })
            .then(({data}) => {
              if(data.statusCode == "Success") {
                this.$messageIotSuccess(this.$t("設定を登録しました"))
                this.back()
              }
            }).finally(() => {
              this.showLoading = false
            })
          }else{
            let optionDetailList = []
            let choiceList = []
            for(let choice of this.query.questionList[0].questionAnswerList){
              choiceList.push({
                choiceId : choice.choiceId ? choice.choiceId : null,
                choiceContent : choice.content,
                otherFlag : choice.otherExistsFlag
              })
            }
            optionDetailList.push({
              detailId:this.query.questionList[0].detailId,
              content : this.query.questionList[0].questionContent,
              commonFlag : true,
              inputMode : this.query.questionList[0].questionInputMode,
              mustFlag : this.query.questionList[0].mustFlag,
              choiceList : choiceList
            })

            let query = {
              optionTitle : '共通',
              buildingId : this.buildingId,
              optionRemark : null,
              commonShowFlag : false,
              commonFlag : true,
              optionDetailList : optionDetailList
            }
            SystemManageApi.updateBuildReservationOption(this.commonOptionId,query)
            .catch((error) => {
              errorCodeMsg(error, this)
              this.showLoading = false
            })
            .then(({data}) => {
              if(data.statusCode == "Success") {
                this.$messageIotSuccess(this.$t("設定を登録しました"))
                this.back()
              }
            }).finally(() => {
              this.showLoading = false
            })
          }
        }else{
          if(this.questionAreaFlag){
            this.questionAreaFlag = false
          }
          this.showLoading = false
        }
      });
    }

  },
  watch: {

  },
  computed: {
    rules() {
      const dynamicRules = {};
      this.query.questionList.forEach((question, index) => {
        dynamicRules[`questionList.${index}.questionContent`] = this.dynamicRules.questionContent;

        if(question.questionInputMode == "01"){
          dynamicRules[`questionList.${index}.maxLength`] = [{
            validator: (rule, value, callback) => {
              if (this.$IsNullOrEmpty(value)) {
                callback(new Error(this.$t("message.common.validation.required", {
                  field:  this.$t('label.help.question.common.maxCharactersLength')
                })));
              } else {
                callback();
              }
            },
            trigger: ['blur', 'change']
          },{
            validator: (rule, value, callback) => {
              var lenght = parseInt(value, 10)
              if (lenght < 1 || lenght > 300) {
                callback(new Error(this.$t("message.common.validation.maxCharactersLengthErrMessage", {
                  length1: 1,
                  length2: 300
                })));
              } else {
                callback();
              }
            },
            trigger: ['blur', 'change']
          },{
            validator: (rule, value, callback) => {
              if (!/^[0-9]*$/.test(value)) {
                callback(new Error(this.$t("message.common.validation.numberRequired")));
              } else {
                callback();
              }
            },
            trigger: ['blur', 'change']
          }];
        }

        question.questionAnswerList.forEach((answ, optionIndex) => {
          dynamicRules[`questionList.${index}.questionAnswerList.${optionIndex}.content`] = this.dynamicRules.optionContent;
        });
      });

      return { ...this.otherRules, ...dynamicRules};
    }
  },
  mounted() {

  },
  created() {
    this.buildingId = this.$route.params.buildingId
    this.commonOptionId =this.$route.query.commonOptionId
    if(this.commonOptionId != null && this.commonOptionId != ''){
      this.createFlag = false
      this.getCommonOption()
    }else{
      this.createFlag = true
    }
    let breadcrumb = [
      {
        path: "/",
        title: "label.router.home",
      },
      {
        path: "/system/setting/various",
        title: "label.router.set",
      },
      {
        path: "",
        title: "label.router.comprehensive",
      },
      {
        path: `/system/buildings/${this.buildingId}/detail`,
        title: "label.router.building",
      },
      {
        path: "",
        title: "label.router.reserveOptionSite",
      },
      {
        path: "",
        title: "label.router.commonItemEdit",
      }
    ]
    this.$store.dispatch("menuActive/restBreadcrumb", breadcrumb);

  }
}
</script>

<style lang="scss" scoped>
::v-deep .cancel-width {
  .my-button {
    width: 188px;
    height: 32px;
  }
}

.background-white-04 ::v-deep {
  width: 100%;
  height: auto;
  background-color: #F7F7F2;
  padding: 32px 20px 32px 20px;
  .el-form-item__error {
    color: #F56C6C;
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
    position: absolute;
    top: 28px;
    left: 0;
    margin-top: 0px;
  }
}
.form-group-start {
  display: flex;
  align-items: flex-start;
}
.text-area-04 {
  width: 100%;
}
::v-deep .el-form-item {
  margin-bottom: 0px;
}
.title-area ::v-deep {
  .el-input .el-input__inner {
    width: 100%;
    height: 40px !important;
    border-radius: 8px !important;
    font-size: 24px;
    background: #F7F7F2;//F7F7F2
    color: #525250 !important;
    border: none;
    box-shadow: none !important;
  }
}
.delimit-5 {
  margin-top: 5px;
  margin-bottom: 5px;
}

.text-area-style ::v-deep {
  .el-textarea__inner{
    width: 100% !important;
    height: 80px !important;
    background: #f7f7f2 !important;
    box-shadow: none !important;
  }
  .el-input__count{
      padding-bottom: 10px !important;
  }
}
.ask-area ::v-deep {
  min-width: 82px;
  min-height: 80px;
  padding: 12px 0px 14px 26px;
  border-left: 1px solid black;
}
.display-align-flex {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.common-display-align-flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.common-edit-text-style{
  font-family: Hiragino Kaku Gothic Pro;
  font-size: 14px;
  font-weight: 300;
  line-height: 21px;
  text-align: left;
}
.font-size-weight-700 {
  font-family: 'Inter';
  font-size: 14px;
  font-weight: 700;
  line-height: 16.94px;
  text-align: left;
  color: #000000;
}
.m-top-12 {
  margin-top: 12px;
}
.mark-question-area ::v-deep {
  width: 100%;
  height: auto;
  background-color:#F7F7F2;
  padding: 42px 932px 42px 28px;
  .el-input .el-input__inner {
    width: 100px;
    height: 30px !important;
    border-radius: 8px !important;
    background: #F7F7F2;
    color: #525250 !important;
    border: none;
    box-shadow: none !important;
    padding: 0 !important;
  }
}
.common-question-area ::v-deep {
  width: 100%;
  height: auto;
  background-color:#F7F7F2;
  padding: 18px 28px;
  .el-input .el-input__inner {
    width: 100px;
    height: 30px !important;
    border-radius: 8px !important;
    background: #F7F7F2;
    color: #525250 !important;
    border: none;
    box-shadow: none !important;
    padding: 0 !important;
  }
}
.m-bottom-10 {
  margin-bottom: 10px !important
}
.authentic-question-area ::v-deep {
  width: 100%;
  height: auto;
  background-color:#F7F7F2;
  padding: 20px 54px 32px 28px;
  .el-input .el-input__inner {
    width: 100%;
    height: 30px !important;
    border-radius: 8px !important;
    background: #F7F7F2;
    color: #525250 !important;
    border: none;
    box-shadow: none !important;
    padding: 0 !important;
  }
  .el-radio {
    margin-right: 0px !important;
  }
  .el-checkbox {
    line-height: 0px !important;
    margin-bottom: 0px !important;
  }
}
.authentic-question-area .max-characters{
  margin-left: auto;
  display: flex;
  align-items: center;
  ::v-deep .el-input .el-input__inner {
    padding-left: 15px !important;
    font-size: 14px;
    width: 160px !important;
    height: 44px !important;
    box-shadow: inset -2px -2px 4px #fff, inset -2px -2px 4px #fff, inset 2px 2px 4px #e6e6d8, inset 2px 2px 4px #e6e6d8 !important;
  }
}
.with-100  ::v-deep{
  .el-form-item__error{
    color: #F56C6C;
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
    position: relative;
    top: 100%;
    left: 0;
    margin-top: -10px;
  }
}
.delimit-8 {
  margin-top: 7px;
}
.select-type ::v-deep {
  .el-input .el-input__inner {
    height: 40px !important;
    border-radius: 8px !important;
    background: #F7F7F2;
    color: #525250 !important;
    border: none;
    box-shadow: none !important;
    padding: 20px !important;
  }
}
.displaynone {
  display: none;
}
.weight-size-300 {
  font-family: 'Hiragino Kaku Gothic Pro';
  font-size: 14px;
  font-weight: 300;
  line-height: 21px;
  text-align: left;
  color: #525250;
}
.m-left-22 {
  margin-left: 22px;
}
.cur-pointer {
  cursor: pointer;
}
.width-888 {
  min-width: 888px;
}
.m-left-10 {
  margin-left: 10px !important;
}
.width-100{
  width: 100%;
}
.input-textarea ::v-deep{
  .el-textarea__inner {
    pointer-events: none;
    width: 100% !important;
    height: 160px !important;
  }
}
.weight-size-600 {
  font-family: 'Hiragino Kaku Gothic Pro';
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
  text-align: left;
  color: #525250;
}
.font-style{
  font-size: 14px;
  font-weight: 300;
  line-height: 21px;
  color: #525250;
}
.flex-space-between-center {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.img-w-height-36 {
  width: 36px;
  height: 36px;
}
.text-area-style ::v-deep {
  .el-textarea__inner{
    width: 100% !important;
    height: 80px !important;
    background: #f7f7f2 !important;
    box-shadow: none !important;
  }
  .el-input__count{
      padding-bottom: 10px !important;
  }
}
.content-area ::v-deep {
  .el-input .el-input__inner {
    width: 95%;
    height: 40px !important;
    border-radius: 8px !important;
    font-size: 16px;
    background: #F7F7F2;
    color: #525250 !important;
    border: none;
    box-shadow: none !important;
    box-shadow:#00000000 !important
  }
  .el-input__count{
    background: #F7F7F2;
  }
}
.m-left-12{
  margin-left: 12px;
}
.common-open-style{
  height: 60px;
  border-radius: 8px 8px 0px 0px;
  background: #EBEBE6;
}
.common-question-title-style{
  font-family: Hiragino Kaku Gothic Pro;
  font-size: 20px;
  font-weight: 600;
}
.mast-star-style{
  font-family: Hiragino Kaku Gothic Pro;
  font-size: 20px;
  font-weight: 600;
  color: #BF564C;
}
.common-title-style{
  font-family: Hiragino Kaku Gothic Pro;
  font-size: 20px;
  font-weight: 300;
  color: #525250;
}
.m-top-32{
  margin-top: 32px;
}
.common-remark-style{
  //styleName: Japanese W3 14;
  font-family: Hiragino Kaku Gothic Pro;
  font-size: 14px;
  font-weight: 300;
  margin-top: 8px;
  color: #525250;
}
</style>
